import { render, staticRenderFns } from "./AssociationsTable.vue?vue&type=template&id=491192a2"
import script from "./AssociationsTable.vue?vue&type=script&lang=js"
export * from "./AssociationsTable.vue?vue&type=script&lang=js"
import style0 from "./AssociationsTable.vue?vue&type=style&index=0&id=491192a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
